import * as React from "react";
import { Column } from "primereact/column";
import { Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";
import PageLayout from "../../components/PageLayout";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { DataTable } from "primereact/datatable";
import useEntitiesList from "../../utils/listHookNew";
import { DropdownFilterElement, renderHeader } from "../../components/TableUtils";
import { getRolesDomain } from "../../auth/roles";
import classNames from 'classnames';
import { deleteUser } from "../../api/users";
import Can from "../../auth/Can";
import roles from "../../auth/roles";

export default function UsersList({ opt }) {
  let dtable;

  const [result, loading, setLoading, globalFilter, setGlobalFilter, forceRefresh] = useEntitiesList("users", "users.attributes -> 'surname', users.attributes -> 'name' asc", undefined, "");

  const [openModal, setOpenModal] = React.useState(false);
  const toggle = () => setOpenModal(!openModal);

  const onDelete = async id => {
    const value = await deleteUser(id);
    toggle();
    forceRefresh();
    return value;
  };

  const modalSection = () => (
    <Modal zIndex={2000} centered size="sm" isOpen={openModal ? true : false} backdrop={true}>
      <ModalHeader toggle={toggle}>
        Eliminazione Utente
      </ModalHeader>
      <ModalBody>
        <p>Confermi di voler eliminare l'Utente?</p>
      </ModalBody>
      <ModalFooter>
        <Button color="link" className="btn-link-dark" onClick={toggle}>Annulla</Button>{' '}
        <Button color="danger" className="ml-auto" onClick={() => onDelete(openModal._id)}>Elimina</Button>
      </ModalFooter>
    </Modal>
  );

  const getHeader = () => {
    return (
      <div className="action-container">
        <Link className="btn btn-primary p-button-icon-only" to={`add-user`} title="Aggiungi utente">
          <i className="pi pi-plus mr-2"></i>Nuovo Utente
        </Link>
      </div>
    );
  };

  const onRefresh = () => {
    forceRefresh();
    setGlobalFilter("");
  }

  const exportTable = () => {
    dtable.exportCSV();
  }

  return (
    <PageLayout title="Elenco Utenti">
      <Row>
        <Col>
          <DataTable
            ref={el => {
              dtable = el;
            }}
            loading={loading}
            value={result}
            rowsPerPageOptions={[5, 10, 20, 50, 100]}
            className="p-datatable-hoverable-rows p-datatable-customers"
            responsive
            paginator={true}
            autoLayout={false}
            first={0}
            rows={20}
            totalRecords={result.length}
            paginatorPosition="both"
            header={renderHeader(loading, result.length, undefined, getHeader(), { globalFilter, setGlobalFilter, onRefresh }, exportTable)}
            globalFilter={globalFilter}
            emptyMessage={() => (<div className="text-center">Nessun utente in tabella</div>)}
            paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink"
            currentPageReportTemplate="Visualizzati {first} di {last} Utenti su un totale di {totalRecords}"
          >
            <Column
              field="attributes.surname"
              style={{ wordWrap: "break-word" }}
              header="Cognome"
              sortable
              filter
              filterMatchMode="contains"
              body={(rowData, column) => {
                return (
                  <Link
                    to={`users/${rowData._id}`}
                  >
                    {rowData.attributes.surname}
                  </Link>
                );
              }}
            />
            <Column
              field="attributes.name"
              style={{ wordWrap: "break-word" }}
              header="Nome"
              sortable
              filter
              filterMatchMode="contains"
            />
            <Column
              field="attributes.phone"
              header="Telefono"
              sortable
              filter
              filterMatchMode="contains"
              style={{ wordWrap: "break-word" }}
            />
            <Column
              field="attributes.email"
              header="Email"
              sortable
              filter
              filterMatchMode="contains"
              style={{ wordWrap: "break-word" }}
            />
            <Column
              field="role"
              header="Ruolo"
              sortable
              filter
              filterElement={
                <DropdownFilterElement
                  field="role"
                  options={getRolesDomain()}
                  onChange={e => dtable.filter(e.value, e.field, e.type)}
                />
              }
              body={(rowData, column) => {
                return (
                  <span className={classNames('customer-badge', 'role-' + rowData.role)}>{rowData.role}</span>
                );
              }}
              style={{ wordWrap: "break-word", textAlign: "center" }}
            />
            <Column
              field="tenant"
              header="Dealer"
              sortable
              filter
              filterMatchMode="contains"
              style={{ wordWrap: "break-word" }}
            />

            <Column
              field="actions"
              body={(rowData, column) => {
                return (
                  <div className="action-container">
                    <Link
                      title="Gestisci utente"
                      className="btn btn-sm btn-primary p-button-icon-only"
                      to={`users/${rowData._id}`}
                    >
                      <i className="pi pi-pencil"></i>
                    </Link>
                    <Can
                      roles={[roles.ADMIN]}
                      yes={() => (
                        <Button
                          color="danger"
                          title="Elimina utente"
                          onClick={() => setOpenModal(rowData)}
                          className="btn-sm p-button-icon-only"
                        >
                          <FontAwesomeIcon icon="trash-alt" />
                        </Button>
                      )}
                      no={() => null}
                    />
                  </div>
                );
              }}
              style={{ wordWrap: "break-word" }}
            />
          </DataTable>
        </Col>
      </Row>
      {modalSection()}
    </PageLayout>
  );
}
